var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCiiDarkLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 499.89 121.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#3f3f46;stroke-miterlimit:10;stroke-width:6px;}.cls-2{fill:#3f3f46;}.cls-3{isolation:isolate;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M186.66,58.89c-2.02,1.01-6.55,2.09-12.46,2.09-16.78,0-25.42-10.44-25.42-24.27,0-16.56,11.81-25.78,26.5-25.78,5.69,0,10.01,1.15,11.95,2.16l-2.23,8.71c-2.23-.94-5.33-1.8-9.22-1.8-8.71,0-15.48,5.26-15.48,16.06,0,9.72,5.76,15.84,15.55,15.84,3.31,0,6.98-.72,9.14-1.58l1.66,8.57Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M227.19,42.26c0,12.89-9.15,18.79-18.58,18.79-10.3,0-18.22-6.77-18.22-18.15s7.49-18.65,18.79-18.65,18,7.42,18,18Zm-25.49,.36c0,6.05,2.52,10.58,7.2,10.58,4.25,0,6.98-4.25,6.98-10.58,0-5.26-2.02-10.58-6.98-10.58-5.26,0-7.2,5.4-7.2,10.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.96,36.28c0-4.39-.14-8.14-.29-11.23h9.5l.5,4.82h.22c1.44-2.23,5.04-5.62,10.87-5.62,7.2,0,12.6,4.75,12.6,15.12v20.88h-10.95v-19.51c0-4.54-1.58-7.63-5.54-7.63-3.02,0-4.82,2.09-5.54,4.1-.29,.65-.43,1.73-.43,2.74v20.31h-10.94v-23.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.08,50.68c2.02,1.22,6.19,2.67,9.43,2.67s4.68-1.15,4.68-2.95-1.08-2.66-5.19-4.03c-7.27-2.45-10.08-6.41-10.01-10.58,0-6.55,5.62-11.52,14.33-11.52,4.11,0,7.78,.94,9.94,2.02l-1.94,7.56c-1.58-.86-4.61-2.02-7.63-2.02-2.67,0-4.18,1.08-4.18,2.88,0,1.66,1.37,2.52,5.69,4.03,6.7,2.3,9.5,5.69,9.58,10.87,0,6.55-5.18,11.38-15.26,11.38-4.61,0-8.71-1.01-11.38-2.45l1.95-7.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M318.7,15.26c0,3.02-2.3,5.47-5.9,5.47s-5.76-2.45-5.69-5.47c-.07-3.17,2.23-5.54,5.76-5.54s5.76,2.38,5.83,5.54Zm-11.3,45V25.05h10.94V60.26h-10.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M327.05,50.68c2.02,1.22,6.19,2.67,9.43,2.67s4.68-1.15,4.68-2.95-1.08-2.66-5.19-4.03c-7.27-2.45-10.08-6.41-10.01-10.58,0-6.55,5.62-11.52,14.33-11.52,4.11,0,7.78,.94,9.94,2.02l-1.94,7.56c-1.58-.86-4.61-2.02-7.63-2.02-2.67,0-4.18,1.08-4.18,2.88,0,1.66,1.37,2.52,5.69,4.03,6.7,2.3,9.5,5.69,9.58,10.87,0,6.55-5.18,11.38-15.26,11.38-4.61,0-8.71-1.01-11.38-2.45l1.95-7.85Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M376.15,14.97v10.08h7.85v8.06h-7.85v12.75c0,4.25,1.01,6.19,4.32,6.19,1.37,0,2.45-.14,3.24-.29l.07,8.28c-1.44,.58-4.03,.94-7.13,.94-3.53,0-6.48-1.22-8.21-3.02-2.02-2.09-3.03-5.47-3.03-10.44v-14.4h-4.68v-8.06h4.68v-7.63l10.73-2.45Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M399.56,46.15c.36,4.54,4.83,6.7,9.94,6.7,3.74,0,6.77-.5,9.72-1.44l1.44,7.42c-3.6,1.44-7.99,2.16-12.75,2.16-11.95,0-18.79-6.91-18.79-17.93,0-8.93,5.54-18.79,17.79-18.79,11.38,0,15.7,8.86,15.7,17.57,0,1.87-.22,3.53-.36,4.32h-22.68Zm12.89-7.49c0-2.66-1.15-7.13-6.19-7.13-4.61,0-6.48,4.18-6.77,7.13h12.96Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M429.93,36.28c0-4.39-.14-8.14-.29-11.23h9.5l.5,4.82h.22c1.44-2.23,5.04-5.62,10.87-5.62,7.2,0,12.6,4.75,12.6,15.12v20.88h-10.95v-19.51c0-4.54-1.58-7.63-5.54-7.63-3.02,0-4.82,2.09-5.54,4.1-.29,.65-.43,1.73-.43,2.74v20.31h-10.94v-23.98Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M484.8,14.97v10.08h7.85v8.06h-7.85v12.75c0,4.25,1.01,6.19,4.32,6.19,1.37,0,2.45-.14,3.24-.29l.07,8.28c-1.44,.58-4.03,.94-7.13,.94-3.53,0-6.48-1.22-8.21-3.02-2.02-2.09-3.02-5.47-3.02-10.44v-14.4h-4.68v-8.06h4.68v-7.63l10.73-2.45Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.87,88v24.26h-3.13v-24.26h3.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M167.9,99.55c0-1.8-.04-3.28-.14-4.72h2.81l.18,2.88h.07c.86-1.66,2.88-3.28,5.76-3.28,2.41,0,6.16,1.44,6.16,7.42v10.4h-3.17v-10.04c0-2.81-1.04-5.15-4.03-5.15-2.09,0-3.71,1.48-4.25,3.24-.14,.4-.22,.94-.22,1.48v10.47h-3.17v-12.71Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M207.61,111.61c-.83,.43-2.66,1.01-5,1.01-5.26,0-8.68-3.56-8.68-8.89s3.67-9.25,9.36-9.25c1.87,0,3.53,.47,4.39,.9l-.72,2.45c-.76-.43-1.94-.83-3.67-.83-4,0-6.16,2.95-6.16,6.59,0,4.03,2.59,6.51,6.05,6.51,1.8,0,2.99-.47,3.89-.86l.54,2.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.17,103.41c0,6.44-4.46,9.25-8.67,9.25-4.72,0-8.35-3.46-8.35-8.96,0-5.83,3.82-9.25,8.64-9.25s8.39,3.63,8.39,8.96Zm-13.82,.18c0,3.82,2.2,6.7,5.29,6.7s5.29-2.84,5.29-6.77c0-2.95-1.48-6.7-5.22-6.7s-5.36,3.46-5.36,6.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M245.37,99.55c0-1.8-.04-3.28-.14-4.72h2.77l.14,2.81h.11c.97-1.66,2.59-3.2,5.47-3.2,2.38,0,4.18,1.44,4.93,3.49h.07c.54-.97,1.22-1.73,1.94-2.27,1.04-.79,2.2-1.22,3.85-1.22,2.3,0,5.72,1.51,5.72,7.56v10.26h-3.1v-9.86c0-3.35-1.22-5.36-3.78-5.36-1.8,0-3.2,1.33-3.74,2.88-.14,.43-.25,1.01-.25,1.58v10.76h-3.1v-10.44c0-2.77-1.22-4.79-3.64-4.79-1.98,0-3.42,1.58-3.92,3.17-.18,.47-.25,1.01-.25,1.55v10.51h-3.1v-12.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284.36,104.12c.07,4.28,2.81,6.05,5.98,6.05,2.27,0,3.64-.4,4.82-.9l.54,2.27c-1.12,.5-3.02,1.08-5.8,1.08-5.36,0-8.57-3.53-8.57-8.78s3.1-9.39,8.17-9.39c5.69,0,7.2,5,7.2,8.21,0,.65-.07,1.15-.11,1.48h-12.24Zm9.29-2.27c.04-2.02-.83-5.15-4.39-5.15-3.2,0-4.61,2.95-4.86,5.15h9.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M326.34,88v24.26h-3.13v-24.26h3.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M339.37,99.55c0-1.8-.04-3.28-.14-4.72h2.81l.18,2.88h.07c.86-1.66,2.88-3.28,5.76-3.28,2.41,0,6.16,1.44,6.16,7.42v10.4h-3.17v-10.04c0-2.81-1.04-5.15-4.03-5.15-2.09,0-3.71,1.48-4.25,3.24-.14,.4-.22,.94-.22,1.48v10.47h-3.17v-12.71Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M367.41,94.84l3.42,9.79c.58,1.58,1.04,3.02,1.4,4.46h.11c.4-1.44,.9-2.88,1.48-4.46l3.38-9.79h3.31l-6.84,17.42h-3.02l-6.62-17.42h3.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M392.21,104.12c.07,4.28,2.81,6.05,5.97,6.05,2.27,0,3.64-.4,4.82-.9l.54,2.27c-1.12,.5-3.02,1.08-5.79,1.08-5.36,0-8.57-3.53-8.57-8.78s3.1-9.39,8.17-9.39c5.69,0,7.2,5,7.2,8.21,0,.65-.07,1.15-.11,1.48h-12.24Zm9.29-2.27c.04-2.02-.83-5.15-4.39-5.15-3.2,0-4.61,2.95-4.86,5.15h9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M415.25,109.02c.94,.61,2.59,1.26,4.17,1.26,2.3,0,3.38-1.15,3.38-2.59,0-1.51-.9-2.34-3.24-3.2-3.13-1.12-4.61-2.84-4.61-4.93,0-2.81,2.27-5.11,6.01-5.11,1.76,0,3.31,.5,4.28,1.08l-.79,2.3c-.68-.43-1.94-1.01-3.56-1.01-1.87,0-2.92,1.08-2.92,2.38,0,1.44,1.04,2.09,3.31,2.95,3.02,1.15,4.57,2.66,4.57,5.25,0,3.06-2.38,5.22-6.51,5.22-1.91,0-3.67-.47-4.9-1.19l.79-2.41Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M441.17,89.83v5h4.54v2.41h-4.54v9.39c0,2.16,.61,3.38,2.38,3.38,.83,0,1.44-.11,1.84-.22l.14,2.38c-.61,.25-1.58,.43-2.81,.43-1.48,0-2.66-.47-3.42-1.33-.9-.94-1.22-2.48-1.22-4.54v-9.5h-2.7v-2.41h2.7v-4.18l3.1-.83Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M472.13,103.41c0,6.44-4.46,9.25-8.67,9.25-4.72,0-8.35-3.46-8.35-8.96,0-5.83,3.82-9.25,8.64-9.25s8.39,3.63,8.39,8.96Zm-13.82,.18c0,3.82,2.2,6.7,5.29,6.7s5.29-2.84,5.29-6.77c0-2.95-1.48-6.7-5.22-6.7s-5.36,3.46-5.36,6.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M483.33,100.27c0-2.05-.04-3.82-.14-5.44h2.77l.11,3.42h.14c.79-2.34,2.7-3.82,4.82-3.82,.36,0,.61,.04,.9,.11v2.99c-.32-.07-.65-.11-1.08-.11-2.23,0-3.82,1.69-4.25,4.07-.07,.43-.14,.94-.14,1.48v9.29h-3.13v-11.99Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 149,
    y: 72.17,
    width: 345,
    height: 5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60,14.17c-25.96,0-47,21.04-47,47s21.04,47,47,47,47-21.04,47-47h0c0-25.96-21.04-47-47-47Zm3.92,69.26v7.34h-8.21v-6.69c-4.39-.2-8.71-1.25-12.71-3.08l2.27-10c3.95,2.02,8.3,3.12,12.73,3.21,3.67,0,6.26-1,6.26-3.31s-2.16-3.6-7.49-5.26c-7.85-2.52-13.39-6.19-13.39-13.46,0-6.55,4.54-11.74,12.74-13.39v-6.7h8.14v6.12c3.78,.02,7.53,.8,11,2.3l-2.31,9.58c-3.43-1.6-7.17-2.44-10.95-2.45-4.25,0-5.55,1.51-5.55,3.1,0,1.8,2.45,3.17,8.5,5.25,9.05,3.01,12.37,7.13,12.37,13.68s-4.76,12.17-13.4,13.76Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 60,
    cy: 61.17,
    r: 57
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiiDarkLogo);
export default __webpack_public_path__ + "static/media/CII_Dark_Logo.ac199842b6a46e63f41f6b3faaf24591.svg";
export { ForwardRef as ReactComponent };